import ReactECharts from "echarts-for-react";

interface BarItem {
  name: string;
  value: number;
}

interface HorizontalBarProps {
  data: BarItem[];
  color?: string;
  height?: number;
}

export function HorizontalBar({
  data,
  color = "#00553E",
  height,
}: HorizontalBarProps) {
  const sorted = [...data].sort((a, b) => a.value - b.value);
  const computedHeight = height ?? Math.max(180, sorted.length * 36);

  const option = {
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    grid: { left: 130, right: 36, top: 8, bottom: 16 },
    xAxis: {
      type: "value",
      axisLine: { show: false },
      splitLine: { lineStyle: { type: "dashed", opacity: 0.4 } },
    },
    yAxis: {
      type: "category",
      data: sorted.map((d) => d.name),
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { fontSize: 11, width: 120, overflow: "truncate" },
    },
    color: [color],
    series: [
      {
        type: "bar",
        data: sorted.map((d) => d.value),
        barMaxWidth: 20,
        itemStyle: { borderRadius: [0, 4, 4, 0] },
        label: { show: true, position: "right", fontSize: 11 },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ width: "100%", height: computedHeight }}
      notMerge
    />
  );
}
